var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "pa-0", attrs: { fluid: "" } },
    _vm._l(_vm.rows, function (row, rowIdx) {
      return _c(
        "v-layout",
        { key: rowIdx, attrs: { wrap: "" } },
        _vm._l(row.Columns, function (col, colIdx) {
          return _c(
            "v-flex",
            _vm._b(
              { key: colIdx, staticClass: "pa-2", attrs: { xs12: "" } },
              "v-flex",
              _vm.flexProps(col.Width),
              false
            ),
            [
              _c(_vm.widgetComponentMap[col.Widget], {
                ref: `widget-${rowIdx}-${colIdx}`,
                refInFor: true,
                tag: "component",
                attrs: {
                  "widget-id": `${rowIdx}-${colIdx}`,
                  config: col.Config,
                  "min-width": col.MinimumWidth,
                },
              }),
            ],
            1
          )
        }),
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }